<template>
  <div>
    <el-dialog :visible.sync="shuiwbmdialog" width="1200px" :close-on-click-modal="false" append-to-body
               v-dialogDrag>
      <div>
        <div class="alledit" style="font-size:20px; padding:10px">

          <el-input style="width:350px" placeholder="请输入税务编码、名称、简称、关键字、说明" prefix-icon="el-icon-search"
                    v-model="likeSearchtosee" clearable @input="forserchgrouptosee">
          </el-input>
        </div>
        <div class="alledit-table">
          <el-table ref="multipleTable" border :data="toseetableData" tooltip-effect="dark"
                    style="width: 100%" height="250">
            >
            <el-table-column width="55" align="center" fixed="left">
              <template slot-scope="scope">
                <el-radio :label="scope.$index" v-model="selectionCount"
                          @change="handleSelectionChangeTosee(scope.row,scope.$index)"></el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="shuisbm" label="税务编码">
            </el-table-column>
            <el-table-column prop="shangpmc" label="名称">
            </el-table-column>
            <el-table-column prop="shangpbmjc" label="简称">
            </el-table-column>
            <el-table-column prop="zzssl" label="税率">
              <template slot-scope="scope">
                <p v-if="scope.row.zzssl == '0.13'">13%</p>
                <p v-if="scope.row.zzssl == '0.12'">12%</p>
                <p v-if="scope.row.zzssl == '0.11'">11%</p>
                <p v-if="scope.row.zzssl == '0.10'">10%</p>
                <p v-if="scope.row.zzssl == '0.09'">9%</p>
                <p v-if="scope.row.zzssl == '0.08'">8%</p>
                <p v-if="scope.row.zzssl == '0.07'">7%</p>
                <p v-if="scope.row.zzssl == '0.06'">6%</p>
                <p v-if="scope.row.zzssl == '0.05'">5%</p>
                <p v-if="scope.row.zzssl == '0.04'">4%</p>
                <p v-if="scope.row.zzssl == '0.03'">3%</p>
                <p v-if="scope.row.zzssl == '0.015'">1.5%</p>
                <p v-if="scope.row.zzssl == '0.01'">1%</p>
                <p v-if="scope.row.zzssl == '0.00'">0%</p>
                <p v-if="scope.row.zzssl == '0'">0%</p>
              </template>
            </el-table-column>
            <el-table-column prop="guanjz" label="关键字">
            </el-table-column>
            <!--<el-table-column prop="taxRate" label="税率" ></el-table-column> -->
            <el-table-column label="说明">
              <template slot-scope="slot">
                <el-popover trigger="hover" placement="top">
                  <p>{{ slot.row.shuom }}</p>
                  <div slot="reference" class="name-wrapper">
                    <el-tag size="medium" class="text_slice ">{{ slot.row.shuom }}</el-tag>
                  </div>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>

        </div>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChangetosee" @current-change="handleCurrentChangetosee"
                       :key="elementui_page_component_key2" :current-page="currentpage2" :page-sizes="[10, 20, 30, 40,100]"
                       :page-size="pagenumtosee" layout="total, sizes, prev, pager, next, jumper" :total="totaltosee">
        </el-pagination>

        <div class="buttomanniu">
          <el-button plain type="primary" @click="fixreturnForm()">确定</el-button>
          <el-button @click="fixForm()">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 商品主数据 -->
    <!-- 编辑弹层 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="900px" :close-on-click-modal="false" append-to-body
               :before-close="closediag">
      <!-- <minhead :Stringtitle="title" :isdiag="true"></minhead> -->
      <el-form :model="ruleForm" :rules="title=='查看商品信息'?'':rules" ref="ruleForm" label-width="150px"
               class="demo-ruleForm">
        <div class="demo-ruleForm-item">

          <el-form-item label="商品编号:" prop="shangpbm" :label-width="formLabelWidth">
            <el-input v-model.trim="ruleForm.shangpbm" style="width:215px"
                      :disabled="title=='查看商品信息'?true:false "></el-input>
            <el-button v-if="title == '新增商品信息'" size="mini" plain native-type="button" style="width: 10px;margin-left: 5px;" color="red" @click="getGoodsNumberByCode()"><i class="el-icon-refresh" style="width: 10px;margin-left: -7px;"></i></el-button>
          </el-form-item>
          <el-form-item label="商品名称:" prop="shangpmc" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.shangpmc" style="width:215px"
                      :disabled="title=='查看商品信息'?true:false "></el-input>
          </el-form-item>

        </div>

        <div class="demo-ruleForm-item">
          <el-form-item label="商品英文名称:" prop="shangpywmc" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.shangpywmc" style="width:215px"
                      :disabled="title=='查看商品信息'?true:false "></el-input>
          </el-form-item>
          <el-form-item label="启用/停用:" prop="shifyx" :label-width="formLabelWidth">
            <el-select v-model="ruleForm.shifyx" :disabled="title=='查看商品信息'?true:false ">
              <el-option label="启用" value="1"></el-option>
              <el-option label="停用" value="0"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="demo-ruleForm-item">
          <!-- <el-form-item label="税务编码:" prop="shuiwbm" :label-width="formLabelWidth"> -->
          <!-- <el-input v-model="ruleForm.shuiwbm" style="width:215px" :disabled="title=='查看商品信息'?true:false "></el-input> -->
          <!-- </el-form-item> -->
          <el-form-item label="税务编码" prop="shuiwbm" :label-width="formLabelWidth">
            <div @click="shuiwbmName">
              <div style="width:198px;padding-left: 15px; border: 1px solid #DCDFE6;height: 32px;border-radius: 4px;"
                   :class="title == '查看商品信息' ?'hui':''">{{ruleForm.shuiwbm}}
              </div>
              <img v-if="title == '查看商品信息' ? false : true"
                   style="position:absolute; top:50%;right:5px;transform: translate(-50%,-50%); cursor: pointer;"
                   width="15px" height="14px" src="../../assets/img/pic.png" />
            </div>
          </el-form-item>

          <el-form-item label="规格型号:" prop="guigxh" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.guigxh" style="width:215px" :disabled="title=='查看商品信息'?true:false ">
            </el-input>
          </el-form-item>

        </div>
        <div class="demo-ruleForm-item">
          <el-form-item label="单位:" prop="danw" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.danw" style="width:215px" :disabled="title=='查看商品信息'?true:false ">
            </el-input>
          </el-form-item>
          <el-form-item label="单价:" prop="danj" :label-width="formLabelWidth">
            <el-input v-model="ruleForm.danj" style="width:215px" :disabled="title=='查看商品信息'?true:false "
                      @input="invalidForm('danj')"></el-input>
          </el-form-item>
        </div>

        <div class="demo-ruleForm-item">
          <el-form-item label="税率:" prop="shuil" :label-width="formLabelWidth">
            <el-select v-model="ruleForm.shuil" :disabled="title=='查看商品信息'?true:false " style="width:215px">
              <el-option value="0.13" label="13%"></el-option>
              <el-option value="0.12" label="12%"></el-option>
              <el-option value="0.11" label="11%"></el-option>
              <el-option value="0.10" label="10%"></el-option>
              <el-option value="0.09" label="9%"></el-option>
              <el-option value="0.08" label="8%"></el-option>
              <el-option value="0.07" label="7%"></el-option>
              <el-option value="0.06" label="6%"></el-option>
              <el-option value="0.05" label="5%"></el-option>
              <el-option value="0.04" label="4%"></el-option>
              <el-option value="0.03" label="3%"></el-option>
              <el-option value="0.015" label="1.5%"></el-option>
              <el-option value="0.01" label="1%"></el-option>
              <el-option value="0.00" label="0%"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="税率类型:" prop="lingslbz" :label-width="formLabelWidth">
            <el-select style="width:215px" v-model="ruleForm.lingslbz"
                       :disabled="title=='查看商品信息'?true:false ">
              <el-option label="正常税率" value=""></el-option>
              <el-option label="出口退税" value="0"></el-option>
              <el-option label="免税" value="1"></el-option>
              <el-option label="不征收" value="2"></el-option>
              <el-option label="普通零税率" value="3"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="demo-ruleForm-item">
          <el-form-item label="税收优惠政策:" prop="youhzcbz" :label-width="formLabelWidth">
            <el-select v-model="ruleForm.youhzcbz" :disabled="title=='查看商品信息'?true:false "
                       style="width:215px">
              <el-option label="不使用" value="0"></el-option>
              <el-option label="使用" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="税收优惠政策说明:" :prop="ruleForm.youhzcbz=='1'?'youhzcsm':''"
                        :label-width="formLabelWidth" v-if="ruleForm.youhzcbz=='1'">
            <el-select v-model="ruleForm.youhzcsm" :disabled="title=='查看商品信息'?true:false "
                       style="width:215px">
              <el-option v-for="(item,index) in newoptionlist" :key="index" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="demo-ruleForm-item">
          <el-form-item label="是否可见:" prop="shifkj" :label-width="formLabelWidth">
            <el-select v-model="ruleForm.shifkj" :disabled="title=='查看商品信息'?true:false "
                       style="width:215px">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否默认:" prop="shifmr" :label-width="formLabelWidth">
            <el-select v-model="ruleForm.shifmr" :disabled=true style="width:215px">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>


      <div class="buttomanniu">
        <el-button plain type="primary" @click="submitForm('ruleForm')" v-if="title!='查看商品信息'">保存</el-button>
        <el-button @click="returnForm()">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogFormVisible: {
      //开启弹框
      type: Boolean,
      default: false
    },
    ruleForm: {
      //开启弹框
      type: Object,
      default: {}
    },
    title: {
      //开启弹框
      type: String,
      default: ""
    },
  },
  data() {
    var validateShangpbm = (rule, value, callback) => {
      var reg = /^[A-z0-9]+$/gi; //
      if (!reg.test(value)) {
        callback(new Error('只能输入字母和数字'));
      } else {
        callback();
      }
    };
    var validateDanj = (rule, value, callback) => {
      var reg = /^(([1-9][0-9]*)|(([0]\.\d{1,10}|[1-9][0-9]*\.\d{1,10})))$/;
      if (!reg.test(value) & this.notemptyandnull(value)) {
        callback(new Error('只能输入保留10位的金额数字'));
      } else {
        callback();
      }
    };
    var validateShangpmc = (rule, value, callback) => {
      var reg = /^[\u4e00-\u9fa5A-z0-9]+$/gi; //
      if (!reg.test(value)) {
        callback(new Error('只能输入汉字和英文字母'));
      } else {
        callback();
      }
    };
    return {
      toseetableData: [],
      shuiwbmdialog: false,
      //搜索
      likeSearchtosee: '',
      rules: {
        shangpmc: [{
          required: true,
          message: '请输入商品名称',

          trigger: 'blur'
        },
          //{validator: validateShangpmc, trigger: 'blur'},
          {
            max: 100,
            message: '长度在 100个字符',
            trigger: 'blur'
          }
        ],
        shangpbm: [{
          required: true,
          message: '请输入商品编号',
          trigger: 'blur'
        },
          //{validator: validateShangpbm, trigger: 'blur'},
          {
            max: 30,
            message: '长度在 30个字符',
            trigger: 'blur'
          }
        ],
        shangpywmc: [{
          max: 100,
          message: '长度在 100个字符',
          trigger: 'blur'
        }],
        shifyx: [{
          required: true,
          message: '请选择是否启用/停用',
          trigger: 'blur'
        }, ],
        shifkj: [{
          required: true,
          message: '请选择是否是否可见',
          trigger: 'blur'
        }, ],
        shifmr: [{
          required: true,
          message: '请选择是否是否默认',
          trigger: 'blur'
        }, ],
        shuiwbm: [{
          required: true,
          message: '请输入税务编码',
          trigger: 'blur'
        }, ],
        danj: [{},
          {
            validator: validateDanj,
            trigger: 'blur'
          }
        ],
        shuil: [{
          required: true,
          message: '请选择税率',
          trigger: 'blur'
        }, ],
        youhzcbz: [{
          required: true,
          message: '请选择税收优惠政策',
          trigger: 'blur'
        }, ],
        youhzcsm: [{
          required: true,
          message: '请选择税收优惠政策说明',
          trigger: 'blur'
        }, ],
        guigxh: [{
          max: 40,
          message: '长度在 40个字符',
          trigger: 'blur'
        }],
      },
      formLabelWidth: '150px',
      currentpage2: 1,
      elementui_page_component_key2: "",
      pagetosee: 1,
      pagenumtosee: 10,
      totaltosee: '',
      goodshuiwbmval: "",
      goodshuilval: "0",
      selectionCount: -1,
      newoptionlist: [{
        label: '简易征收',
        value: '1'
      },
        {
          label: '按3%简易征收',
          value: '2'
        },
        {
          label: '按5%简易征收',
          value: '3'
        },
        {
          label: '按5%简易征收减按1.5%计征',
          value: '4'
        },
        {
          label: '100%先征后退',
          value: '5'
        },
        {
          label: '50%先征后退',
          value: '6'
        },
        {
          label: '不征税',
          value: '7'
        },
        {
          label: '先征后退',
          value: '8'
        },
        {
          label: '免税',
          value: '9'
        },
        {
          label: '即征即退100%',
          value: '10'
        },
        {
          label: '即征即退70%',
          value: '11'
        },
        {
          label: '即征即退50%',
          value: '12'
        },
        {
          label: '即征即退30%',
          value: '13'
        },
        {
          label: '稀土产品',
          value: '14'
        },
        {
          label: '超税负3%即征即退',
          value: '15'
        },
        {
          label: '超税负8%即征即退',
          value: '16'
        },
        {
          label: '超税负12%即征即退',
          value: '17'
        },
      ],
    }
  },
  watch: {
    dialogFormVisible: function(indexVal, oldVal) {
      if (indexVal) {
        this.$nextTick(() => {
          this.$refs['ruleForm'].clearValidate();
        });
      }
    }
  },
  methods: {
    closediag() {
      this.$emit("closediag", false)
      this.dialogFormVisible = false
    },
    handleSelectionChangeTosee(e, index) {
      this.selectionCount = index;
      this.goodshuiwbmval = e.shuisbm;
      this.goodshuilval = e.zzssl;

    },
    returnForm() {
      this.closediag();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.updateGoods()
        }
      });
    },
    updateGoods() {
      var url = '';
      var type = '';
      this.ruleForm.shifkj = "1";
      this.ruleForm.shifmr = "0";
      if (this.ruleForm.id == '' || this.ruleForm.id == null) {
        url = '/master/addGoods';
        type = '0';
        /*this.ruleForm.qiybh='91500115MA1K3R189Q';*/
      } else {
        url = '/master/updateGoods';
        type = '1';
      }
      let params = {
        goodsData: JSON.stringify(this.ruleForm)
      }
      this.$https.fetchPost(url, params).then(res => {
        if (res.data.success) {
          if (type == '0') {
            this.$message.success(this.$tolertJSON[4032]);
          } else {
            this.$message.success(this.$tolertJSON[4020]);
          }
          this.$emit("addsuccess", "")
          this.dialogFormVisible = false
        } else {
          // this.$message.error(res.data.message)
        }
      })

    },
    invalidForm(type) {
      switch (type) {
        case "danj":
          this.ruleForm.danj = this.ruleForm.danj.replace(/[^\d.]/g, '');
          break;
      }
    },
    shuiwbmName() {
      if (this.title == '查看商品信息') {
        return false;
      }
      this.selectionCount = -1
      this.shuiwbmdialog = true;
      this.getGoodsSWBMList();
    },
    fixForm() {
      this.shuiwbmdialog = false;
    },
    fixreturnForm() {
      if (this.emptyandnull(this.goodshuiwbmval)) {
        this.$message({
          type: 'error',
          message: '请选择数据'
        });
        return false
      }
      /* if (this.goodshuilval != '0.13' && this.goodshuilval != '0.09' && this.goodshuilval != '0.06'
           && this.goodshuilval != '0.05' && this.goodshuilval != '0.03' && this.goodshuilval != '0.015'
           && this.goodshuilval != '0.01' && this.goodshuilval != '0.00') {
           this.$message({
               type: 'error',
               message: '获取税务编码税率不合法'
           });
           return;
       }*/
      this.ruleForm.shuiwbm = this.goodshuiwbmval;
      this.ruleForm.shuil = this.goodshuilval;
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate();
      });
      this.shuiwbmdialog = false;
    },
    handleSizeChangetosee(val) {
      this.pagenumtosee = val;
      this.getGoodsSWBMList();
    },
    handleCurrentChangetosee(val) {
      this.pagetosee = val;
      this.getGoodsSWBMList();
    },
    forserchgrouptosee() {
      this.currentpage2 = 1
      this.elementui_page_component_key2++
      this.getGoodsSWBMList();
    },
    getGoodsSWBMList() {
      let params = {
        page: this.pagetosee,
        limit: this.pagenumtosee,
        likeSearch: this.likeSearchtosee,
        sort: "asc",
        order: "id"
      }
      this.$https.fetchPost('/master/getGoodsSwbmList', params).then(res => {
        console.log(res)
        this.toseetableData = res.data.data
        this.totaltosee = res.data.count

      })
    },
    getGoodsNumberByCode(){
      this.$https.fetchPost('/master/getGoodsNumberByCode').then(res => {
        if (res.data.success) {
          var fromData=JSON.parse(JSON.stringify(this.ruleForm))
          fromData.shangpbm=res.data.obj;
          this.ruleForm=fromData;
        }
      });
    },
  },
}
</script>

<style scoped="scoped" lang="less">
.alledit-table {}

/deep/ .el-radio__label {
  display: none;
}

.hui {
  background-color: #F5F7FA;
}

/deep/ .el-table--small td {
  padding: 4px 0;
}

.plain {
  /* background-color: #b3d8ff; */
  background-color: #409EFF;
  opacity: 0.7;


}

.blue {
  background-color: #409EFF;

}

.sendinput {
  visibility: hidden;
}

.bt1 {
  width: 80px;
  height: 31px;
  border: 1px solid #e5e5e5;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 500;
  color: #2f66fc;
}

/* 编辑弹层 */
.demo-ruleForm-item {
  display: flex;


}

.top {
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 10px;

}

.area1:extend(.between-line) {
  border-bottom: 1px solid #ccc;
  margin-right: 20px;
  box-sizing: border-box;
}

.arealxr:extend(.between-line) {
  border-bottom: 1px solid #ccc;
  margin-right: 10px;
  margin-right: 10px;
  box-sizing: border-box;
}

.alledit {
  display: flex;
  justify-content: space-between;
}

.el-pagination {
  text-align: center;
  margin-top: 20px;
}

/* .move-btn{
    text-align: center;
    margin-top: 20px;
}
/deep/ .el-icon-d-arrow-right{
    transform:rotate(-90deg);

}
/deep/ .el-icon-d-arrow-left{
    transform:rotate(-90deg);

} */

.move-btn {
  text-align: center;
  margin-top: 20px;
}

.el-icon-d-arrow-left,
.el-icon-d-arrow-right {
  transform: rotate(-90deg);
}

.export-img {
  width: 12px;
  height: 12px;
  margin-right: 3px;
  vertical-align: baseline;
}
</style>
